export default __webpack_public_path__ + "fd8de0094d7abe3b1c38ade6604cfdb4.png";